import * as React from "react";
const IcoPhone = () => (
  <svg
    width={"100%"}
    height={"100%"}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="surface9637">
      <path
        id="Vector"
        d="M4.0644 9.93592C6.58595 12.4575 9.41887 13.5177 11.0683 13.9479C11.858 14.1543 12.6769 13.7343 12.9912 12.9796L13.9071 10.7767C14.1572 10.1766 13.8859 9.48528 13.2923 9.21621L11.4256 8.36888C10.8561 8.11002 10.1845 8.23179 9.7419 8.67442L8.90406 9.51226C8.90406 9.51226 7.75193 9.20819 6.2724 7.72792C4.79213 6.24839 4.48806 5.09626 4.48806 5.09626L5.3259 4.25842C5.7678 3.8158 5.88957 3.14421 5.63144 2.57471L4.78411 0.707245C4.51504 0.11441 3.82376 -0.157579 3.22364 0.0932637L1.02074 1.00913C0.266029 1.32268 -0.153987 2.14157 0.052375 2.93201C0.482599 4.58145 1.54285 7.41437 4.0644 9.93592Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export default IcoPhone;
